module.exports=[
  {
    "label": "Salt Lake City",
    "Good": 233,
    "Moderate": 125,
    "Unhealthy for sensitive groups": 7,
    "Unhealthy": 0,
    "Very unhealthy": 0,
    "Hazardous": 0,
    "No data": 0
  },
  {
    "label": "Los Angeles",
    "Good": 91,
    "Moderate": 258,
    "Unhealthy for sensitive groups": 15,
    "Unhealthy": 1,
    "Very unhealthy": 0,
    "Hazardous": 0,
    "No data": 0
  },
  {
    "label": "Ulaanbaatar, Mongolia",
    "Good": 81,
    "Moderate": 103,
    "Unhealthy for sensitive groups": 64,
    "Unhealthy": 34,
    "Very unhealthy": 35,
    "Hazardous": 27,
    "No data": 21
  },
  {
    "label": "Beijing",
    "Good": 68,
    "Moderate": 103,
    "Unhealthy for sensitive groups": 125,
    "Unhealthy": 59,
    "Very unhealthy": 10,
    "Hazardous": 0,
    "No data": 0
  },
  {
    "label": "Kathmandu, Nepal",
    "Good": 55,
    "Moderate": 77,
    "Unhealthy for sensitive groups": 129,
    "Unhealthy": 85,
    "Very unhealthy": 2,
    "Hazardous": 0,
    "No data": 17
  },
  {
    "label": "New Delhi",
    "Good": 6,
    "Moderate": 45,
    "Unhealthy for sensitive groups": 92,
    "Unhealthy": 96,
    "Very unhealthy": 69,
    "Hazardous": 17,
    "No data": 40
  },
  {
    "label": "Dhaka, Bangladesh",
    "Good": 2,
    "Moderate": 49,
    "Unhealthy for sensitive groups": 72,
    "Unhealthy": 80,
    "Very unhealthy": 79,
    "Hazardous": 7,
    "No data": 76
  }
]